var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('v-container',[_c('h1',[_vm._v("Statistiken")]),_c('router-view',{staticStyle:{"margin-top":"20px"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }